// Tiny inline-SVG sparkline: the price path over the window with a dashed line
// at the moving average, tinted by trend. No chart library — keeps the bundle
// small and the mark crisp at row scale.

interface Props {
  data: number[];
  ma: number;
  bullish: boolean;
  width?: number;
  height?: number;
}

export function Sparkline({ data, ma, bullish, width = 96, height = 34 }: Props) {
  if (data.length < 2) return <svg width={width} height={height} />;
  const min = Math.min(...data, ma);
  const max = Math.max(...data, ma);
  const span = max - min || 1;
  const pad = 3;
  const w = width - pad * 2;
  const h = height - pad * 2;
  const x = (i: number) => pad + (i / (data.length - 1)) * w;
  const y = (v: number) => pad + (1 - (v - min) / span) * h;

  const path = data.map((v, i) => `${i === 0 ? "M" : "L"}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(" ");
  const maY = y(ma).toFixed(1);
  const stroke = bullish ? "var(--success)" : "var(--danger)";

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true" class="spark">
      <line x1={pad} y1={maY} x2={width - pad} y2={maY} stroke="var(--neutral-300)" stroke-width="1" stroke-dasharray="2 2" />
      <path d={path} fill="none" stroke={stroke} stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round" />
    </svg>
  );
}
